/**
 * @generated SignedSource<<7db9e11f5d6871b2ce43129b1409ba48>>
 * @relayHash 4a4005367ff18db447d0b795160ab2b3
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 4a4005367ff18db447d0b795160ab2b3

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CommercialCode",
    "kind": "LinkedField",
    "name": "commercialCodes",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sales",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommercialCodesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CommercialCodesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "4a4005367ff18db447d0b795160ab2b3",
    "metadata": {},
    "name": "CommercialCodesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "03b1c37677b919901f049de06188cad9";

export default node;
